import {
  Menu,
  MenuItem,
  FormControlLabel,
  Divider,
  Grid2,
  IconButton,
  Tooltip,
  Checkbox,
  Collapse
} from "@mui/material";
import MaterialBox from "../../../../components/MaterialBox";
import MaterialTypography from "../../../../components/MaterialTypography";
import { ExpandMore, FilterAltOff } from "@mui/icons-material";
import { useEffect, useState } from "react";
import { useLoading } from "../../../../components/Loading";
import { useSnackbar } from "../../../../context/popup";
import { fetchData } from "../../../../services";
import DropDownConfig from "../../../Utils/DropDownConfig";


const GeneralAddonFilterDialog = ({ anchorEl, open, onClose, filterData, setFilterData, onApply }) => {

    const { setCircleLoading } = useLoading();
    const { showSnackbar } = useSnackbar();

    //accordian states
    const [openActive, setOpenActive] = useState(false);
    const [openGeneralProduct, setOpenGeneralProduct] = useState(false);
    const [openPolicyType, setOpenPolicyType] = useState(false);
     //options states
    const [productOptions, setProductOptions] = useState([]);
    const [policyTypeOptions, setPolicyTypeOptions] = useState([]);

    const sectionHeader = {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        padding: "2px 6px",
        background: "#e9ecf5",
        borderRadius: "6px",
        cursor: "pointer",
        mb: 0.5,
    };

    const menuItemStyle = {
        borderRadius: "6px",
        my: 0.2,
        mx: 0.5,
        py: 0.3,
        "&:hover": { backgroundColor: "#dfe6ff" },
    };

    const labelStyle = {
        m: 0,
        "& .MuiFormControlLabel-label": { fontSize: "0.8rem" },
    };

    //dropdown apis
    useEffect(() => {
        if(!open){
            return;
        }
        //dropdown apis for form
        const fetchDropdowns = async () => {
        setCircleLoading(true);
        try {
        const [productResponse, policyTypeResponse] = await Promise.all([
            fetchData(`/reference/general/key-value-store?dropdown=true&code=${DropDownConfig?.generalProduct}`),  //code passing for product
            fetchData(`/reference/general/key-value-store?dropdown=true&code=${DropDownConfig?.generalPolicyType}`)  //code passing for policy type
        ]);
    
            if (productResponse?.success) {
            setProductOptions(
                productResponse.data?.items?.map((item) => ({
                value: item.id,
                label: item.keyName,
                })) || []
            );
            }
    
            if (policyTypeResponse?.success) {
            setPolicyTypeOptions(
                policyTypeResponse.data?.items?.map((item) => ({
                value: item.id,
                label: item.keyName,
                })) || []
            );
            }
        } catch (error) {
            console.error("Error fetching dropdown data:", error);
            showSnackbar("Error fetching filter data","error");
        } finally {
            setCircleLoading(false);
        }
        };
    
        fetchDropdowns();
    }, [open]);

    const handleChange = ({ target: { name, value } }) => {
        setFilterData(prev => ({
            ...prev,
            [name]: value
        }));
    };


    const onClearFilters = () => {
        setFilterData({
            isActive: "",
            policyId: "",
            productId: ""
        });
    };


  return (
    <Menu
      anchorEl={anchorEl}
      open={open}
      onClose={onClose}
      sx={{backgroundColor: "rgba(0, 0, 0, 0.3)",}}
      PaperProps={{
          elevation: 3,
          sx: {
            width: 280,
            padding: 1.5,
          },
      }}
    >
        <MaterialBox
        sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
        }}
        >
            {/* Title */}
            <MaterialTypography variant="body2" fontWeight="bold">
                Add-on Filter
            </MaterialTypography>

            {/* Clear Button */}
            <Tooltip title="Clear Filter" disableInteractive>
                <IconButton
                    size="small"
                    onClick={onClearFilters}
                    sx={{ color: "#ce0707ff" }}
                >
                    <FilterAltOff />
                </IconButton>
            </Tooltip>
        </MaterialBox>


      {/* Content */}
        <MaterialBox ml={1} mt={1}>
            <Grid2 container spacing={1}>
                <Grid2 size={{xs:12}}>
                    <MaterialBox>
                        <MaterialBox sx={sectionHeader} onClick={() => setOpenActive(!openActive)}>
                        <MaterialTypography variant="body3" fontWeight="bold">
                            Active Status
                        </MaterialTypography>

                        <IconButton size="small">
                            <ExpandMore
                            sx={{
                                transform: openActive ? "rotate(180deg)" : "rotate(0deg)",
                                transition: "0.2s",
                            }}
                            />
                        </IconButton>
                        </MaterialBox>

                        <Collapse in={openActive}>
                        <MenuItem
                            disableRipple
                            sx={menuItemStyle}
                            onClick={() =>
                            handleChange({
                                target: { name: "isActive", value: true },
                            })
                            }
                        >
                            <FormControlLabel
                            control={<Checkbox size="small" checked={filterData.isActive === true} />}
                            label="Active"
                            sx={labelStyle}
                            />
                        </MenuItem>

                        <MenuItem
                            disableRipple
                            sx={menuItemStyle}
                            onClick={() =>
                            handleChange({
                                target: { name: "isActive", value: false },
                            })
                            }
                        >
                            <FormControlLabel
                            control={<Checkbox size="small" checked={filterData.isActive === false} />}
                            label="Inactive"
                            sx={labelStyle}
                            />
                        </MenuItem>
                        </Collapse>
                    </MaterialBox>
                </Grid2>
                <Grid2 size={{ xs: 12 }}>
                    <MaterialBox sx={sectionHeader} onClick={() => setOpenGeneralProduct(!openGeneralProduct)}>
                        <MaterialTypography
                        variant="body3"
                        fontWeight="bold"
                        >
                        Product
                        </MaterialTypography>
                        <IconButton size="small">
                            <ExpandMore
                            sx={{
                                transform: openGeneralProduct ? "rotate(180deg)" : "rotate(0deg)",
                                transition: "0.2s",
                            }}
                            />
                        </IconButton>
                    </MaterialBox>

                    <MaterialBox ml={1}>
                        <Collapse in={openGeneralProduct}>
                        {/* Dynamic State List */}
                        {productOptions?.map((state) => (
                        <MenuItem
                            key={state.value}
                            onClick={() =>
                            handleChange({
                                target: { name: "productId", value: state.value },
                            })
                            }
                        >
                            <FormControlLabel
                            sx={{
                                m: 0,
                                "& .MuiFormControlLabel-label": { fontSize: "0.8rem" },
                            }}
                            control={
                                <Checkbox
                                size="small"
                                checked={filterData.productId === state.value}
                                />
                            }
                            label={state.label}
                            />
                        </MenuItem>
                        ))}
                        </Collapse>
                    </MaterialBox>
                </Grid2>
                <Grid2 size={{ xs: 12 }}>
                    <MaterialBox sx={sectionHeader} onClick={() => setOpenPolicyType(!openPolicyType)}>
                        <MaterialTypography
                        variant="body3"
                        fontWeight="bold"
                        >
                        Policy Type
                        </MaterialTypography>
                        <IconButton size="small">
                            <ExpandMore
                            sx={{
                                transform: openPolicyType ? "rotate(180deg)" : "rotate(0deg)",
                                transition: "0.2s",
                            }}
                            />
                        </IconButton>
                    </MaterialBox>

                    <MaterialBox ml={1}>
                        <Collapse in={openPolicyType}>
                            {/* Policy Type List */}
                            {policyTypeOptions?.map((state) => (
                            <MenuItem
                                key={state.value}
                                onClick={() =>
                                handleChange({
                                    target: { name: "policyId", value: state.value },
                                })
                                }
                            >
                                <FormControlLabel
                                sx={{
                                    m: 0,
                                    "& .MuiFormControlLabel-label": { fontSize: "0.8rem" },
                                }}
                                control={
                                    <Checkbox
                                    size="small"
                                    checked={filterData.policyId === state.value}
                                    />
                                }
                                label={state.label}
                                />
                            </MenuItem>
                            ))}
                        </Collapse>
                    </MaterialBox>
                </Grid2>
            </Grid2>

        </MaterialBox>

        <Divider />

        {/* Apply button */}
        <MenuItem
        onClick={() => onApply()}
        disableRipple
        sx={{
            padding: "6px 16px", 
            width: "fit-content",
            minWidth: "0px",
            mx: "auto",  
            borderRadius: "6px",
            backgroundColor: "#bcc7e9",
            color: "white",
            display: "flex",
            justifyContent: "center",
            transition: "0.2s ease",

            "&:hover": {
            backgroundColor: "#93a6e8",
            }
        }}
        >
        <MaterialTypography variant="button" fontWeight="bold">
            APPLY FILTER
        </MaterialTypography>
        </MenuItem>
    </Menu>
  );
};

export default GeneralAddonFilterDialog;
